import { Form } from "antd";
import { useEffect } from "react";
import { FormModal } from "@/shared/components/FormModal";
import {
	useCreateOrganizationType,
	useUpdateOrganizationType,
} from "../hooks/useOrganizationTypes";
import { useOrgTypesStore } from "../store/org-types.store";
import type { CreateOrganizationTypeRequest } from "../types";
import { OrgTypeForm } from "./OrgTypeForm";

export function OrgTypeFormModal() {
	const [form] = Form.useForm<CreateOrganizationTypeRequest>();
	const { modalOpen, editingItem, closeModal } = useOrgTypesStore();

	const { mutate: create, isPending: isCreating } = useCreateOrganizationType();
	const { mutate: update, isPending: isUpdating } = useUpdateOrganizationType();

	const close = () => {
		form.resetFields();
		closeModal();
	};

	useEffect(() => {
		if (modalOpen) {
			if (editingItem) {
				form.setFieldsValue({ name: editingItem.name });
			} else {
				form.resetFields();
			}
		}
	}, [modalOpen, editingItem, form]);

	const handleSubmit = () => {
		form
			.validateFields()
			.then((values) => {
				if (editingItem) {
					update({ id: editingItem.id, data: { name: values.name } }, { onSuccess: close });
				} else {
					create(values, { onSuccess: close });
				}
			})
			.catch(() => {
				// Validation failed - Form shows errors inline
			});
	};

	return (
		<FormModal
			open={modalOpen}
			editing={!!editingItem}
			title="Yangi tashkilot turi"
			editTitle="Tashkilot turini tahrirlash"
			onCancel={close}
			onOk={handleSubmit}
			confirmLoading={isCreating || isUpdating}
		>
			<OrgTypeForm form={form} />
		</FormModal>
	);
}
